<template lang="pug">
    section#menu
        .wrapper
            ul.menu
                li(v-for="item, index in menu" v-if="item.nome != null").opcoes
                    router-link(:to="{ path: '/' + item.slug }", :key="item.nome" v-if="!item.link_externo && (item.link_externo == '#' || item.link_externo == null)") {{ item.nome }}
                    a(:href="item.link_externo", target="_blank", v-else) {{ item.nome }}
                    button(@click="ativarSubmenu(index)" v-if="item.children.length > 0 && item.children[0].nome != null" :class="{'ativo': submenuAtivo && menuAtivo == index}")
                        img(:src="require('@images/icones/arrow.png')")
                    ul.submenu(:class="{'ativo': submenuAtivo && menuAtivo == index}")
                        li(v-for="submenu in item.children", v-if="submenu.nome != null")
                            router-link(:to="{ path: '/' + submenu.slug }", :key="submenu.nome" v-if="!submenu.link_externo  && (item.link_externo == '#' || item.link_externo == null)") {{ submenu.nome }}
                            a(:href="submenu.link_externo", target="_blank", v-else) {{ submenu.nome }}
</template>

<script>
export default {
    name: "section-menu",
    props:{
        menu: Array,
    },
    data() {
        return {
            submenuAtivo: false,
            menuAtivo: false
        }
    },
    methods: {
        ativarSubmenu(index){
            if(this.menuAtivo === index){
                this.submenuAtivo = false
                this.menuAtivo = false
            }else{
                this.submenuAtivo = true
                this.menuAtivo = index
            }
        }
    },
}
</script>

<style lang="stylus" scoped src="./Menu.styl"></style>